/* You must register this file at "website\src\i18n\fa-ir" */

export default {
		/* Global Vocabulary */


		/* Module special vocabulary */
    $LOWER_NAME$s: {
      menu: {
        index: 'عنوان منوی بازشو',
        create: 'ایجاد نام ماژول',
        list: 'لیست ماژول‌ها'
      },
      table_titles: {
				id: 'شناسه',
				title: 'عنوان',
				option: 'انتخاب',
				setting: 'ویرایش / حذف',
			},
		edit: 'ویرایش ماژول'
  }
}
